export const tr = {
    'accept-button': 'Yükselt',
    'many-days-title-hint':
        'Son {daysNumber} günde günlük bütçe sınırlaması nedeniyle kampanyalar durdurulduğu ve etkili tıklamalar kaybedildiği için bu öneri gösterilmektedir.',
    'one-day-title-hint':
        'Son bir günde kampanyalar günlük bütçe sınırlaması nedeniyle durdurulduğu ve etkili tıklamalar kaybedildiği için bu öneri gösterilmektedir.',
    'simple-progress-hint': 'Bütçe sınırı yükseltiliyor',
    'simple-title': 'Повысьте ограничение бюджета до {sum}',
    'some-days-title-hint':
        'Son {daysNumber} günde kampanyalar günlük bütçe sınırlaması nedeniyle durdurulduğu ve etkili tıklamalar kaybedildiği için bu öneri gösterilmektedir.'
};
